/* global Swiper */

document.querySelectorAll( '.b-persons' ).forEach( ( block ) => {

	const modal = block.querySelector( '[data-persons-modal]' );
	const dialog = block.querySelector( '[data-persons-modal-dialog]' );

	if ( !modal || !dialog ) {

		return;

	}

	const modalName = block.querySelector( '[data-persons-modal-name]' );
	const modalBio = block.querySelector( '[data-persons-modal-bio]' );

	if ( !modalName || !modalBio ) {

		return;

	}

	const isSliderLayout = block.classList.contains( 'b-persons--layout-slider' );
	const isSliderAutoplayEnabled = block.dataset.personsSliderAutoplay !== 'false';
	const focusableSelector = [
		'a[href]',
		'button:not([disabled])',
		'textarea:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'[tabindex]:not([tabindex="-1"])',
	].join( ',' );
	/**
	 * Tell whether reduced motion is preferred for this session.
	 *
	 * @return {boolean} True when motion should be minimized.
	 */
	const prefersReducedMotion = () => window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	let sliderInstance = null;
	let activeTrigger = null;
	let pausedIndex = null;
	let autoplayWasRunning = false;

	if ( isSliderLayout && typeof window.Swiper === 'function' ) {

		const sliderViewport = block.querySelector( '.b-persons-grid__viewport' );
		const sliderTrack = block.querySelector( '.b-persons-grid__track' );
		const prevEl = block.querySelector( '.b-persons-grid__nav-button--prev' );
		const nextEl = block.querySelector( '.b-persons-grid__nav-button--next' );

		if ( sliderViewport && sliderTrack ) {

			sliderViewport.classList.add( 'swiper' );
			sliderTrack.classList.add( 'swiper-wrapper' );
			sliderTrack.querySelectorAll( '.wp-block-wombat-persons-card' ).forEach( ( card ) => {

				card.classList.add( 'swiper-slide' );

			} );

			sliderInstance = new Swiper( sliderViewport, {
				slidesPerView: 1.08,
				spaceBetween: 12,
				loop: false,
				watchOverflow: true,
				speed: prefersReducedMotion() ? 0 : 400,
				autoplay: ( prefersReducedMotion() || !isSliderAutoplayEnabled ) ? false : {
					delay: 4000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				a11y: {
					enabled: true,
					prevSlideMessage: prevEl?.getAttribute( 'aria-label' ),
					nextSlideMessage: nextEl?.getAttribute( 'aria-label' ),
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				navigation: ( prevEl && nextEl ) ? { prevEl, nextEl } : false,
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 16,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 16,
					},
				},
			} );

		}

	}

	/**
	 * Return every currently focusable element inside the dialog.
	 *
	 * @return {HTMLElement[]} Focusable elements.
	 */
	const getFocusableElements = () => Array.from( dialog.querySelectorAll( focusableSelector ) ).filter(
		( element ) => element instanceof HTMLElement && !element.hidden
	);

	/**
	 * Pause the current slider without resetting its position.
	 */
	const pauseSlider = () => {

		if ( !sliderInstance ) {

			return;

		}

		pausedIndex = sliderInstance.realIndex;
		autoplayWasRunning = Boolean( sliderInstance.autoplay?.running );

		if ( autoplayWasRunning && sliderInstance.autoplay ) {

			sliderInstance.autoplay.stop();

		}

		sliderInstance.disable();

	};

	/**
	 * Resume the slider from the exact state captured before the modal opened.
	 */
	const resumeSlider = () => {

		if ( !sliderInstance ) {

			return;

		}

		sliderInstance.enable();

		if ( Number.isInteger( pausedIndex ) && sliderInstance.realIndex !== pausedIndex ) {

			sliderInstance.slideToLoop( pausedIndex, 0, false );

		}

		if ( autoplayWasRunning && sliderInstance.autoplay ) {

			sliderInstance.autoplay.start();

		}

		pausedIndex = null;
		autoplayWasRunning = false;

	};

	/**
	 * Fill the modal with the clicked card's content.
	 *
	 * @param {HTMLElement} card Source card.
	 */
	const fillModalFromCard = ( card ) => {

		const name = card.querySelector( '.b-persons-card__name' );
		const bio = card.querySelector( '[data-persons-card-bio]' );

		modalName.textContent = name?.textContent?.trim() || '';
		modalBio.textContent = bio?.textContent?.trim() || '';

	};

	/**
	 * Close the modal and restore focus + slider state.
	 */
	const closeModal = () => {

		if ( modal.hidden ) {

			return;

		}

		modal.hidden = true;
		block.classList.remove( 'is-modal-open' );
		document.body.classList.remove( 'u-overflow-hidden' );
		document.removeEventListener( 'keydown', handleDocumentKeydown );
		resumeSlider();

		if ( activeTrigger instanceof HTMLElement ) {

			activeTrigger.focus();

		}

		activeTrigger = null;

	};

	/**
	 * Handle Escape and focus trap while the modal is open.
	 *
	 * @param {KeyboardEvent} event Keyboard event.
	 */
	const handleDocumentKeydown = ( event ) => {

		if ( modal.hidden ) {

			return;

		}

		if ( event.key === 'Escape' ) {

			event.preventDefault();
			closeModal();
			return;

		}

		if ( event.key !== 'Tab' ) {

			return;

		}

		const focusableElements = getFocusableElements();

		if ( !focusableElements.length ) {

			event.preventDefault();
			dialog.focus();
			return;

		}

		const firstElement = focusableElements[ 0 ];
		const lastElement = focusableElements[ focusableElements.length - 1 ];
		const activeElement = dialog.ownerDocument.activeElement;

		if ( event.shiftKey && activeElement === firstElement ) {

			event.preventDefault();
			lastElement.focus();

		} else if ( !event.shiftKey && activeElement === lastElement ) {

			event.preventDefault();
			firstElement.focus();

		}

	};

	/**
	 * Open the modal from the clicked card.
	 *
	 * @param {HTMLElement} card Source card.
	 * @param {HTMLElement} trigger Trigger element.
	 */
	const openModal = ( card, trigger ) => {

		fillModalFromCard( card );
		activeTrigger = trigger;
		modal.hidden = false;
		block.classList.add( 'is-modal-open' );
		document.body.classList.add( 'u-overflow-hidden' );
		pauseSlider();
		document.addEventListener( 'keydown', handleDocumentKeydown );
		dialog.focus();

	};

	block.addEventListener( 'click', ( event ) => {

		const closeTrigger = event.target instanceof Element ? event.target.closest( '[data-persons-modal-close]' ) : null;

		if ( closeTrigger instanceof HTMLElement ) {

			event.preventDefault();
			closeModal();
			return;

		}

		const trigger = event.target instanceof Element ? event.target.closest( '.b-persons-card__actions .wp-block-button__link, .b-persons-card__actions .wp-element-button' ) : null;

		if ( !( trigger instanceof HTMLElement ) || !block.contains( trigger ) ) {

			return;

		}

		const card = trigger.closest( '.b-persons-card' );

		if ( !( card instanceof HTMLElement ) ) {

			return;

		}

		const bio = card.querySelector( '[data-persons-card-bio]' );

		if ( !bio ) {

			return;

		}

		event.preventDefault();
		openModal( card, trigger );

	} );

} );
